import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ReferenceDataLabels, UserSessionService } from 'rome-library';
import { States } from '../../../shared';
import { TaggingService } from '../../../tag-manager';
import { LoginService } from '../../services/login.service';
import { UserService } from '../../services/user.service';

@UntilDestroy()
@Component({
  selector: 'boi-system-unavailable',
  templateUrl: './system-unavailable.page.html'
})
export class SystemUnavailablePage implements OnInit {
  public readonly referenceDataLabels = ReferenceDataLabels;

  constructor(
    private readonly userService: UserService,
    private readonly loginService: LoginService,
    private readonly userSessionService: UserSessionService,
    private readonly taggingService: TaggingService
  ) {}

  ngOnInit(): void {
    this.taggingService.resetDataLayer();
    this.taggingService.execute();
    if (this.userService.getUser()?.IsAuthenticated) {
      this.logoutUser();
    }
  }

  private logoutUser(): void {
    this.loginService
      .logout(States.Logout)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.userSessionService.stopSession();
      });
  }
}
